module.exports = __webpack_public_path__ + "a8bebe1f9356120f450158cb4ad7a076.png";